module.exports = __webpack_public_path__ + "static/media/kc3.799b72cd.png";